import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import NavigationList from '../../../../components/NavigationList/NavigationList';
import { useDropdownKeyboardNavigation } from '../../../../components/Custom_Hooks/useDropdownKeyboardNavigation';
import useKeyboardNavigation from '../../../../components/Custom_Hooks/useKeyboardNavigation';

const CreateMasters = () => {

  const navigate = useNavigate();
  const location = useLocation();

  const keyMap = {
    'g': '/create-master-group',
    'l': '/create-master-ledger',
    'v': '/create-master-vouchertype',
    's': '/create-master-invmas-stockgroup',
    'c': '/create-master-invmas-stockcategory',
    'y': '/create-master-invmas-stockcompany',
    'i': '/create-master-invmas-stockitem',
    'u': '/create-master-invmas-unit',
    'o': '/create-master-invmas-godown',
    'p': '/create-master-sttdet-pandetails',
  };

  useKeyboardNavigation(keyMap);

  const data = [
    // Accounting Master
    { category: "Accounting Master", to: "/create-master-group", text: "Group" },
    { category: "Accounting Master", to: "/create-master-ledger", text: "Ledger" },
    { category: "Accounting Master", to: "/create-master-vouchertype", text: "Vouchers Type" },
    // Inventory Master
    { category: "Inventory Master", to: "/create-master-invmas-stockgroup", text: "Stock Group" },
    { category: "Inventory Master", to: "/create-master-invmas-stockcategory", text: "Stock Category" },
    { category: "Inventory Master", to: "/create-master-invmas-stockcompany", text: "Stock Company" },
    { category: "Inventory Master", to: "/create-master-invmas-stockitem", text: "Stock Item" },
    { category: "Inventory Master", to: "/create-master-invmas-unit", text: "Unit" },
    { category: "Inventory Master", to: "/create-master-invmas-godown", text: "Godown" },
    // Statutory Details
    { category: "Statutory Details", to: "/create-master-sttdet-pandetails", text: "PAN Details" },
  ];

  const { selectedItemIndex, setSelectedItemIndex } = useDropdownKeyboardNavigation({
    items: data,
    // state:location.pathname==='/create-master-group'|| location.pathname==='/create-master-ledger'|| location?.pathname==='/create-master-invmas-stockgroup'?false:true,
    state: location.pathname === '/createmasters' ? true : false,
    onItemSelect: (item) => {
      // if (['/ledgerbook', '/current_date', '/period','/create-master-ledger','/create-master-invmas-stockgroup'].includes(location.pathname)) {
      //   return;
      // }
      if (location.pathname === '/createmasters') {
        navigate(item.to)
      }
    },

  });
  return (
    <NavigationList
      data={data}
      selectedItemIndex={selectedItemIndex}
      setSelectedItemIndex={setSelectedItemIndex}
      title='Master Creation'
      first_heading='Accounting Master'
      secound_heading='Inventory Masters'
      third_heading='Statutory Details'

    />
  )
}

export default React.memo(CreateMasters);
